<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.account }}</div>
<!--            <div class="member acea-row row-middle">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>-->
          </div>
          <div class="acea-row row-middle" v-if="userInfo.account != userInfo.nickname">
            <div class="name line1">{{ userInfo.nickname }}</div>
          </div>
        </div>
      </div>
<!--      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
      ></span>-->
    </div>

    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/user/account' }" class="item"  v-for="(item, index) in moneyType" :key="index">
          <div>{{item}}</div>
          <div class="num">{{ userInfo[index]}}</div>
        </router-link>
      </div>

<!--      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/' + 100" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>-->
<!--      <div class="myService">
          <div class="title acea-row row-middle">我的业绩</div>
          <div class="nav acea-row row-middle">
            <router-link :to="{ path: '/user/income_month' }" class="item" >
              <div>今日业绩</div>
              <div class="num">{{ userInfo.todayIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income_month' }" class="item" >
              <div>昨日业绩</div>
              <div class="num">{{ userInfo.yesdayIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income_month' }" class="item" >
              <div>7日业绩</div>
              <div class="num">{{ userInfo.weekIncome}}</div>
            </router-link>
          </div>
        <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/income_month' }" class="item"  >
            <div>本月业绩</div>
            <div class="num">{{ userInfo.tomonthIncome}}</div>
          </router-link>
          <router-link :to="{ path: '/user/income_month' }" class="item"  >
            <div>上月业绩</div>
            <div class="num">{{ userInfo.yesmonthIncome}}</div>
          </router-link>
          <router-link :to="{ path: '/user/income_month' }" class="item"  >
            <div>总业绩</div>
            <div class="num">{{ userInfo.allIncome}}</div>
          </router-link>
        </div>
      </div>-->
      <div class="myService">
        <div class="title acea-row row-middle">我的收益</div>
        <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/commission_month' }" class="item" >
            <div>今日收益</div>
            <div class="num">{{ userInfo.todayBonus}}</div>
          </router-link>
          <router-link :to="{ path: '/user/commission_month' }" class="item" >
            <div>昨日收益</div>
            <div class="num">{{ userInfo.yesdayBonus}}</div>
          </router-link>
          <router-link :to="{ path: '/user/commission_month' }" class="item" >
            <div>7日收益</div>
            <div class="num">{{ userInfo.weekBonus}}</div>
          </router-link>
        </div>
        <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/commission_month' }" class="item"  >
            <div>本月收益</div>
            <div class="num">{{ userInfo.tomonthBonus}}</div>
          </router-link>
          <router-link :to="{ path: '/user/commission_month' }" class="item"  >
            <div>上月收益</div>
            <div class="num">{{ userInfo.yesmonthBonus}}</div>
          </router-link>
          <router-link :to="{ path: '/user/commission_month' }" class="item"  >
            <div>总收益</div>
            <div class="num">{{ userInfo.allBonus}}</div>
          </router-link>
        </div>
      </div>
<!--      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>

        </div>
      </div>-->




    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
import { isWeixin } from "@utils/index";
import SwitchWindow from "@components/SwitchWindow";
import { imageBase64,getWechatConfig,getShare } from "@api/public";
import cookie from "@utils/store/cookie";
import GeneralWindow from "@components/GeneralWindow";
import { pay,oAuth,openShareAll } from "@libs/wechat";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
        moneyType:[],
      uid:0,
      nickname:'',
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },

    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },

  methods: {

    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        if(res.data.openid=='' && isWeixin()){
            cookie.set('login_back_url','/user',3600);
            oAuth(res.data.uid);
        }else{
            cookie.remove('login_back_url');
        }

        that.moneyType = res.data.moneyType;

        that.userInfo = res.data;
        that.uid = res.data.uid;
        that.nickname = res.data.nickname;
        that.orderStatusNum = res.data.orderStatusNum;



        if(that.isWeixin){
            that.setOpenShare();
        }
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
    setOpenShare() {
      if (isWeixin()) {

        var href = location.href;
        if(this.uid){
          href =
                  href.indexOf("?") === -1
                          ? href + "?spread=" + this.uid
                          : href + "&spread=" + this.uid;
        }
        var nickname = this.nickname;
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: '['+nickname+'邀请] '+data.synopsis,
            title: data.title,
            link: href,
            imgUrl: data.img
          };
          console.log('['+nickname+'邀请] '+data.synopsis);
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.user .wrapper .myService {
  margin-bottom:0.15rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
